module.exports = __webpack_public_path__ + "static/media/img_final.36b7db54.jpg";